import { Vehicle } from "./vehicle";


// export class Paged<T> {
//     constructor(
//         public totalItems: number,
//         public items: T[]
//     ) { }
// }

export class Conductor {
    public id: number;
    public cnh: string;
    public password: string;
    public collaboratorId: number;
    public cnhExpirationDate: Date;
    public isBlocked: boolean = false;
    public mustResetPassword: boolean = false;
    public deactivationDate?: Date;   
}

export class ConductorCollaborator {
    public id: number;
    public cnh: string;
    public name: string;
    public document: string;
    public register: string;
    public assignorId: number;
    public collaboratorId: number;
    public cnhExpirationDate: Date;
    public vehicles: Vehicle[];
    
    public selected: boolean = false;
}

export class ConductorCollaboratorFilter {
    public name: string;
    public cnh: string;
    public document: string;
    public register: string;
}



